import axios, { AxiosInstance } from "axios";
import qs from "qs";

import { useUserStore } from "@/stores/UserStore";

export default class BaseApiClient {
  protected readonly baseURL: URL;
  protected readonly axiosInstance: AxiosInstance;

  constructor(basePath: string) {
    this.baseURL = new URL(basePath, process.env.VUE_APP_API_BASE_URL);

    this.axiosInstance = axios.create({
      baseURL: `${this.baseURL}`,
      paramsSerializer: (params: any) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });

    this.axiosInstance.interceptors.response.use(
      async (response: any) => {
        const userStore = useUserStore();
        if (response.headers.hasOwnProperty("x-token-expires-at")) {
          userStore.$patch({ tokenExpiresAt: response.headers["x-token-expires-at"] });
        }
        return response;
      },
      (error: any) => {
        return Promise.reject(error);
      }
    );

    this.axiosInstance.interceptors.request.use((config: any) => {
      const userStore = useUserStore();
      config.headers["X-Token"] = userStore.token;
      config.headers["X-User-Id"] = userStore.user?.id;

      return config;
    });
  }
}
